{
  "loading": "Indlæser ...",
  "placeholder": "Vælg…"
}
